class ApiTasks {
    constructor(Restangular, ApiBaseResponseService) {
        return {
            /**
             * Get all tasks
             * @return {Object}
             */
            getTasks() {
                return Restangular.one('tasks')
                    .one('filter')
                    .post()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getTasksFiltered(filterObject) {
                return Restangular.all('tasks')
                    .all('filter')
                    .post(filterObject)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            emailTasks(filterObject) {
                return Restangular.all('tasks')
                    .all('export')
                    .all('email')
                    .post(filterObject)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getTask(taskId) {
                return Restangular.one('tasks', taskId)
                    .get()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            postTask(task) {
                if (task.assignee) {
                    task.assignee = { id: task.assignee.id };
                }

                if (task.campaign) {
                    task.campaign = { campaignId: task.campaign.campaignId };
                }

                return Restangular.all('tasks')
                    .post(task)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            putTask(task) {
                if (task.assignee) {
                    task.assignee = { id: task.assignee.id };
                }

                if (task.campaign) {
                    task.campaign = { campaignId: task.campaign.campaignId };
                }

                var taskId = task.task.taskId;
                return Restangular.one('tasks', taskId)
                    .customPUT(task)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            deleteTasks(taskIds) {
                return Restangular.all('tasks/delete')
                    .post(taskIds)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            deleteTask(taskId) {
                return Restangular.one('tasks', taskId)
                    .remove()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getTasksFilteredCount(filterObject) {
                return Restangular.all('tasks')
                    .all('count')
                    .post(filterObject)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },
        };
    }
}

ApiTasks.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiTasks;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiTasks.js
 **/